module.exports = __webpack_public_path__ + "img/register-success.2cb43306.png";